
{
  "familyId": "STU-FLOWCHART",
  "questions": [
    {
      "id": "STU-FLOWCHART-001",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "multiple_choice",
      "question": "In een flowchart staat een ruitvorm met daarin 'Is het antwoord > 10?'. Wat betekent deze vorm?",
      "options": ["Een beslissing (ja of nee)", "Een actie die je moet uitvoeren", "Het begin van het proces", "Het einde van het proces"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vormen in een flowchart",
            "content": "Ruit = beslissing (ja/nee). Rechthoek = actie/stap. Ovaal = begin of einde. Pijl = richting van het proces.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_ruit",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een ruitvorm in een flowchart betekent een beslissing. Er komen twee pijlen uit: één voor 'ja' en één voor 'nee'. Het proces volgt de pijl die past bij het antwoord.",
        "solutionSteps": [
          "Ruit = beslissing (ja/nee vraag)",
          "Twee uitgangen: ja-pijl en nee-pijl",
          "Het proces volgt de juiste pijl"
        ],
        "distractorExplanations": {
          "0": "Goed! Een ruit is altijd een beslissing met twee mogelijke uitgangen.",
          "1": "Een actie staat in een rechthoek, niet in een ruit.",
          "2": "Het begin staat in een ovaal (afgeronde rechthoek), niet in een ruit.",
          "3": "Het einde staat ook in een ovaal, niet in een ruit."
        }
      }
    },
    {
      "id": "STU-FLOWCHART-002",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "multiple_choice",
      "question": "Een flowchart begint met 'Start', dan 'Pak een paraplu' als het regent, anders 'Ga naar buiten'. Wat gebeurt er als het NIET regent?",
      "options": ["Je gaat direct naar buiten zonder paraplu", "Je pakt een paraplu", "Je gaat terug naar Start", "Het proces stopt"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Flowchart volgen",
            "content": "Volg altijd de pijlen. Bij een beslissing (ruit) kies je de pijl die past bij je antwoord. 'Regent het?' → Nee → volg de nee-pijl naar 'Ga naar buiten'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_volgen",
      "variantIndex": 2,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Bij een beslissing in een flowchart (de ruitvorm) volg je altijd de pijl die past bij je antwoord. De beslissing is hier: 'Regent het?' Het antwoord is 'Nee', dus je volgt de nee-pijl. Die leidt naar 'Ga naar buiten' — zonder paraplu. De regel bij flowcharts is: lees de vraag in de ruit, bepaal je antwoord (ja of nee), en volg de bijbehorende pijl. Je slaat de stappen op de andere pijl over.",
        "solutionSteps": [
          "Start → je komt bij de beslissing: 'Regent het?'",
          "Het regent NIET → antwoord is 'Nee'",
          "Volg de nee-pijl → 'Ga naar buiten' (zonder paraplu)",
          "De ja-pijl (paraplu pakken) sla je over"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij 'nee' volg je de nee-pijl naar 'Ga naar buiten' zonder paraplu.",
          "1": "Een paraplu pak je alleen als het WEL regent (de ja-pijl). Een veelgemaakte denkfout bij flowcharts is beide paden volgen — je kiest altijd maar één pad bij een beslissing.",
          "2": "Terug naar Start zou een lus zijn, maar die staat hier niet in de flowchart. Een terugwijzende pijl moet expliciet getekend zijn — als die er niet is, ga je niet terug.",
          "3": "Het proces stopt pas bij een 'Einde'-ovaal, niet bij een beslissing. Een ruit (beslissing) heeft altijd twee uitgangen (ja/nee) — het proces gaat altijd verder via één van die pijlen."
        }
      }
    },
    {
      "id": "STU-FLOWCHART-003",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "multiple_choice",
      "question": "Waarvoor gebruik je een flowchart?",
      "options": ["Om de stappen van een proces overzichtelijk weer te geven", "Om getallen met elkaar te vergelijken", "Om delen van een geheel te tonen", "Om veranderingen over tijd te laten zien"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wanneer een flowchart?",
            "content": "Een flowchart toont de stappen van een proces in volgorde, inclusief beslissingen. Het is handig voor instructies, recepten, of het uitleggen van een procedure.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_doel",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Een flowchart maakt de stappen van een proces overzichtelijk. Je ziet de volgorde, de beslissingen en de mogelijke paden. Het is anders dan een grafiek (tijd) of diagram (vergelijken).",
        "solutionSteps": [
          "Flowchart = stappen van een proces",
          "Toont volgorde + beslissingen",
          "Anders dan grafieken of diagrammen"
        ],
        "distractorExplanations": {
          "0": "Goed! Een flowchart toont processtappen overzichtelijk.",
          "1": "Getallen vergelijken doe je met een staafdiagram of tabel.",
          "2": "Delen van een geheel toon je met een cirkeldiagram.",
          "3": "Veranderingen over tijd toon je met een lijndiagram."
        }
      }
    },
    {
      "id": "STU-FLOWCHART-004",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "multiple_choice",
      "question": "In een flowchart staat een pijl die terugwijst naar een eerdere stap. Wat betekent dit?",
      "options": ["Een herhaling (lus): je herhaalt stappen tot een voorwaarde klopt", "Er is een fout in de flowchart", "Je moet het hele proces opnieuw beginnen", "Het proces is klaar"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lussen in flowcharts",
            "content": "Een pijl die terugwijst maakt een lus (herhaling). Je herhaalt de stappen tot een beslissing een andere uitkomst geeft. Bijvoorbeeld: 'Is het klaar? Nee → doe het opnieuw.'",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_lus",
      "variantIndex": 4,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Een terugwijzende pijl maakt een lus (herhaling). Je herhaalt bepaalde stappen tot een voorwaarde verandert. Dit is normaal in flowcharts en geen fout.",
        "solutionSteps": [
          "Terugwijzende pijl = lus (herhaling)",
          "Stappen worden herhaald",
          "Tot een beslissing een andere uitkomst geeft"
        ],
        "distractorExplanations": {
          "0": "Goed! Een terugwijzende pijl is een lus — stappen worden herhaald.",
          "1": "Het is geen fout. Lussen zijn een normaal onderdeel van flowcharts.",
          "2": "Je herhaalt niet het hele proces, alleen de stappen binnen de lus.",
          "3": "Het proces is pas klaar bij een 'Einde'-ovaal."
        }
      }
    },
    {
      "id": "STU-FLOWCHART-005",
      "familyId": "STU-FLOWCHART",
      "module": "Studievaardig",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "schemas",
      "subSkill": "schema_flowchart",
      "questionType": "matching",
      "question": "Koppel elke flowchartvorm aan de juiste betekenis.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Ovaal", "right": "Begin of einde" },
          { "left": "Rechthoek", "right": "Actie of stap" },
          { "left": "Ruit", "right": "Beslissing (ja/nee)" },
          { "left": "Pijl", "right": "Richting van het proces" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Flowchartvormen",
            "content": "Ovaal = begin/einde. Rechthoek = actie. Ruit = beslissing. Pijl = richting.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "flowchart_vormen_match",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Ovaal = begin/einde. Rechthoek = actie/stap. Ruit = beslissing (ja/nee). Pijl = richting van het proces.",
        "solutionSteps": [
          "Ovaal → Begin of einde",
          "Rechthoek → Actie of stap",
          "Ruit → Beslissing (ja/nee)",
          "Pijl → Richting van het proces"
        ]
      }
    }
  ]
}
